import script from "./StudentResult.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentResult.vue?vue&type=script&setup=true&lang=js"

import "./StudentResult.vue?vue&type=style&index=0&id=00629de9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00629de9"]])

export default __exports__